(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.facebookAdStatsBreakdowns = definition();

    }

    function definition() {

        return {
            AGE_GENDER: {
                breakdownName: 'age_gender',
                breakdownComponents: ['age', 'gender']
            },
            PLACEMENT: {
                breakdownName: 'placement',
                breakdownComponents: ['device_platform', 'publisher_platform', 'platform_position']
            },
            PUBLISHER_PLATFORM: {
                breakdownName: 'publisher_platform',
                breakdownComponents: ['publisher_platform']
            },
            REGION: {
                breakdownName: 'region',
                breakdownComponents: ['region']
            }
        };
    }
})();
